import { FC, useEffect, useState } from 'react';
import { useBooleanValue } from '@edikk-edikk/hooks';
import { SeoLinkType } from '@edikk-edikk/country-frontend';
import { useCallbackRef } from '@restart/hooks';
import { Block } from '@edikk-edikk/country-layout-black';
import { SeoBlockContext, SeoBlockContextType } from './contexts';
import { SeoBlockActionHolder } from './SeoBlockActionHolder';
import { SeoBlockContent } from './SeoBlockContent';

type PropsType = {
  text: string|null;
  linkList?: SeoLinkType[];
  cityList?: SeoLinkType[];
  containerAdditionalClassName?: string;
};

const SeoBlock: FC<PropsType> = ({
  text,
  linkList = null,
  cityList = null,
  containerAdditionalClassName = undefined,
}) => {
  const [isVisible, , , toggle] = useBooleanValue(false);
  const [contentElement, attachContentElement] = useCallbackRef<HTMLDivElement>();
  const [maxHeight, setMaxHeight] = useState<number>(0);

  useEffect(() => {
    if (!contentElement) {
      return;
    }

    setMaxHeight(contentElement.scrollHeight);
  }, [contentElement]);

  if (
    !text
    && (!linkList || linkList.length === 0)
    && (!cityList || cityList.length === 0)
  ) {
    return null;
  }

  const seoBlockContextValue: SeoBlockContextType = {
    toggle,
    isVisible,
    text,
    linkList,
    cityList,
    attachContentElement,
    maxHeight,
  };

  return (
    <SeoBlockContext.Provider value={seoBlockContextValue}>
      <Block additionalClassName={containerAdditionalClassName}>
        <SeoBlockActionHolder />
        <SeoBlockContent />
      </Block>
    </SeoBlockContext.Provider>
  );
};

export { SeoBlock };
